import padron from '../images/loga/padron1.png'
import arturoFuente from '../images/loga/arturo-fuente2.png'
import olivia from '../images/loga/oliva.png'
import nub from '../images/loga/nub.png'
import cain from '../images/loga/cain.png'
import laGarela from '../images/loga/laGarela.png'
import laFlorDominicana from '../images/loga/la.png'
import ciboa from '../images/loga/ciboa.png'


export const BrandsSectionData = [
    {
        name: 'Padron',
        imgUrl: padron,
        path: '/cigar/padron'
    },
    {
        name: 'Arturo Fuente',
        imgUrl: arturoFuente,
        path: '/cigar/arturo-fuente'
    },
    {
        name: 'Olivia',
        imgUrl: olivia,
        path: '/cigar/olivia'
    },
    {
        name: 'Nub',
        imgUrl: nub,
        path: '/cigar/nub'
    },
    {
        name: 'Cain',
        imgUrl: cain,
        path: '/cigar/cain'
    },
    {
        name: 'La Garela',
        imgUrl: laGarela,
        path: '/cigar/la-garela'
    },
    {
        name: 'La Flor Dominicana',
        imgUrl: laFlorDominicana,
        path: '/cigar/la-flor-dominicana'
    },
    {
        name: 'Ciboa',
        imgUrl: ciboa,
        path: '/cigar/ciboa'
    },


]